import HorizontalScroller from './HorizontalScroller';
export default HorizontalScroller;
